import "./TotalVehivlesCard.scss";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useEffect } from "react";

import { Box } from "@mui/material";

import { LargeTitle } from "../../common-components/Titles/Titles";
import { CommonTitle } from "../../common-components/Titles/Titles";

import { fetchCardsStatistic } from "../../slices/transportStatistic";

const TotalVehiclesCard = ({ params }) => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token?.data?.token || state.auth.token);

    const cards = useSelector((state) => state.transportStatistic.cards);

    useEffect(() => {
        dispatch(fetchCardsStatistic({ token, params }));
    }, [dispatch, token, params]);

    return (
        <Box className={"total_vehicles_card"}>
            <Box className={"total_vehicles_card_container"}>
                <Box className={"total_vehicles_card_container_count"}>
                    <LargeTitle property={cards["Всего"] ?? 0} />
                </Box>
                <Box className={"total_vehicles_card_container_description"}>
                    <CommonTitle property={"Всего транспорта"} />
                </Box>
            </Box>
        </Box>
    );
};

export default TotalVehiclesCard;